/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Free': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M144.41 75.738c0 38.123-30.905 69.03-69.028 69.03-38.125 0-69.03-30.907-69.03-69.03 0-38.125 30.905-69.029 69.03-69.029 38.123 0 69.029 30.904 69.029 69.03" _fill="#BCBBBD" fill-rule="evenodd"/>'
  }
})
